import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { SVGIconComponent } from '@progress/kendo-angular-icons';

@Component({
    selector: 'app-secondary-button',
    templateUrl: './secondary-button.component.html',
    styleUrls: ['./secondary-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, SVGIconComponent],
})
export class SecondaryButtonComponent {
  @Input() type: 'button' | 'submit' = 'button';
  @Input() disabled = false;
  @Input() icon?: SVGIcon;
  @Input() iconPosition: 'left' | 'right' = 'left';
}
